<template>
  <div id="Sites">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-text-field
              style="max-width: 250px"
              dense
              outlined
              hide-details
              clearable
              :placeholder="$t('general.search')"
              v-model="search"
              append-icon="search"
              class="mr-2"
              @keyup.enter="searching"
              @click:append="searching"
            />
            <v-btn color="primary" depressed to="sites/add">{{$t('sites.add')}}</v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="sites"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td align="left">{{props.item.name}}</td>
                  <td align="left">{{props.item.manager ? props.item.manager : '- -'}}</td>
                  <td align="left">{{props.item.phone ? props.item.phone : '- -'}}</td>
                  <td align="left">{{props.item.email ? props.item.email : '- -'}}</td>
                  <td align="left">{{props.item.address ? props.item.address.country.name : ''}}</td>
                  <td align="left">{{props.item.address ? props.item.address.zip_code : ''}}</td>
                  <td align="center">
                    {{props.item.lat ? props.item.lat : '--'}} / {{props.item.lng ? props.item.lng : '--'}}
                    <p v-if="props.item.external_inspections === 1">
                      {{`(${$t('general.isExternal')})`}}
                    </p>
                  </td>
                  <td align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mr-4" small @click="addUsers(props.item)" v-on="on">fas fa-plus</v-icon>
                      </template>
                      <span>{{$t('sites.addUsers')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mr-4" small @click="edit(props.item.id)" v-on="on">far fa-edit</v-icon>
                      </template>
                      <span>{{$t('general.edit')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="remove(props.item)" v-on="on">far fa-trash-alt</v-icon>
                      </template>
                      <span>{{$t('general.remove')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('sites.delMessage')}}?</p>
          <p><span class="font-weight-black error--text">{{$t('general.site')}}: </span>{{removedItem.name}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="error"
            text
            @click="close"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="error"
            depressed
            @click="confirmRemove"
          >{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeUserDialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('sites.delUserMessage')}}?</p>
          <p><span class="font-weight-black error--text">{{$t('general.user')}}: </span>{{removedUser.name + ' '+ removedUser.last_name}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="error"
            text
            @click="removeUserDialog = false"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="error"
            depressed
            @click="confirmRemoveUser"
          >{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" width="700px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="primary--text">{{$t('sites.addUsers')}}</h3>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col><span><h3 class="primary--text">{{$t('general.site')}}: </h3> {{editedItem.name}}</span></v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <h3 class="primary--text mb-2">{{$t('sites.relatedUsers')}}: </h3>
              <v-chip class="mb-2" color="primary" v-for="(item, index) in editedItem.users" :key="item.id">
                {{item.name + ' ' + (item.last_name ? item.last_name : '')}}  &nbsp;
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon small @click="removeUser(item, index)" v-on="on">far fa-trash-alt</v-icon>
                  </template>
                  <span>{{$t('general.remove')}}</span>
                </v-tooltip>
              </v-chip>
              <span v-if="editedItem.users.length < 1">{{$t('sites.noUsers')}}</span>
            </v-col>
            <v-col cols="6">
              <h3 class="primary--text mb-2">{{$t('sites.addUsers')}}: </h3>
              <v-form
                lazy-validation
                ref="form"
                v-model="valid"
              >
                <v-autocomplete
                  outlined
                  multiple
                  :items="filterUsers"
                  :item-text="text"
                  item-value="id"
                  v-model="selectedUsers"
                  :rules="rules.required"
                >
                  <template v-slot:label>
                    <span>{{$t('general.users')}}</span><span class="error--text">&nbsp;*</span>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.name + ' ' + data.item.last_name}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="data">
                    <v-chip>{{data.item.name + ' ' + data.item.last_name}}</v-chip>
                  </template>
                </v-autocomplete>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" text @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn :loading="loading" :disabled="loading" color="primary" depressed @click="saveUsers">{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Sites',
    data () {
    return {
      loadTable: true,
      loading: false,
      valid: false,
      addDialog: false,
      dialog: false,
      removeUserDialog: false,
      search: '',
      pageCount: 0,
      editedItem: {
        site: {
          name: ''
        },
        users: ''
      },
      defaultItem: {
        site: {
          name: ''
        },
        users: ''
      },
      selectedUsers: '',
      users: [],
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      removedItem: {
        name: ''
      },
      removedUser: {
        name: ''
      },
      sites: [],
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    search (val) {
      if (val === '' || val === null) this.searching()
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: this.$t('general.name'),
          value: 'name',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.manager'),
          value: 'manager',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.phone'),
          value: 'phone',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.email'),
          value: 'email',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('address.country'),
          value: 'address.country',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('address.zip'),
          value: 'zip_code',
          align: 'left',
          sortable: true
        },
        {
          text: 'Lat/Long',
          value: 'lat',
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
    },
    filterUsers () {
      if (this.editedItem.users.length > 0) {
        let users = this.users
        this.editedItem.users.forEach(user => {
          users = users.filter(item => item.id !== user.id)
        })
        return users
      } else {
        return this.users
      }
    }
  },
  methods: {
    text: item => item.name + ' ' + item.last_name,
    close () {
      this.dialog = false
      this.addDialog = false,
      this.removeUserDialog = false,
      this.loading = false,
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = { name: '' }
      this.selectedUsers = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    addUsers (item) {
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.users.length < 1) {
        this.editedItem.users = ''
      } else {
        this.editedItem.originalUsers = this.editedItem.users
      }
      this.addDialog = true
    },
    saveUsers () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let users = []
        this.selectedUsers.forEach(item => {
          users.push({user_id: item})
        })
        this.$store.dispatch('sites/addUsers', {event: {item: {users, id: this.editedItem.id}, context: this}})
      }
    },
    removeUser(item, index) {
      this.removedUser = item
      this.removedUser.index = index
      this.removeUserDialog = true 
    },
    edit (id) {
      this.$router.push('sites/edit/' + id)
    },
    remove (item) {
      this.removedItem = item
      this.dialog = true
    },
    confirmRemove () {
      this.loading = true
      this.$store.dispatch('sites/delete', {event: {item: this.removedItem, context: this}})
    },
    confirmRemoveUser () {
      this.loading = true
      this.$store.dispatch('sites/deleteUser', {event: {item: {user: this.removedUser, site: this.editedItem.id}, context: this}})
    },
    searching () {
      this.options.page = 1
      this.options.perPage = 5
      this.get()
    },
    get () {
      this.loadTable = true
      this.$store.dispatch('sites/get', {
        event: {
          item: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'desc' : 'asc',
            find: this.search
          },
          context: this
        }
      })
    },
    initialize () {
      this.loadTable = true
      this.$store.dispatch('sites/get', {
        event: {
          item: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
            find: this.search
          },
          context: this
        }
      })
      this.$store.dispatch('users/getAll', {event: {context: this}})
    }
  }
}
</script>